import Transform from "./Transform.js";
import Indicator from "./Indicator.js";

// const log = global.log.getLogger("f_mtac.scene.placer");

const Placer = function(group) {
    const indicator = new Indicator(group);

    Object.defineProperty(this, "indicator_position", {
        set: () => {},
        get: () => indicator.position
    });

    this.init = ({color}) => {
        if (color === undefined) {
            color = "#000";
        }
        this.end();
        indicator.init({color});
    };

    this.move = (p) => {
        indicator.move(p);
    };

    this.move_to = (p) => {
        indicator.move_to(p);
    };

    this.end = () => {
        indicator.end();
    };

};

Placer.transform = new Transform({k: 1});
export default Placer;
